var _templateObject, _templateObject2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { Flex } from '@finect/tabular-core/Flex';
import { ButtonLined } from '@finect/tabular-core/ButtonLined';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { Select } from '../../Select';
import { SectionAction } from '../SectionAction';
import { Title, Subtitle } from './Headings';
import { CenteredTitle } from './CenteredTitle';
var BottonViewMore = styled(ButtonLined).withConfig({
  displayName: "Header__BottonViewMore",
  componentId: "sc-e1c24-0"
})(["height:40px;padding:7px 9px;margin:1px 0 0 8px;", ";"], minMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-left: 4px;\n  "]))));
var ExpandContainer = styled(Flex).withConfig({
  displayName: "Header__ExpandContainer",
  componentId: "sc-e1c24-1"
})(["margin-bottom:12px;", ";"], minMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-left: auto;\n  "]))));
var HeaderBlock = styled.header.withConfig({
  displayName: "Header__HeaderBlock",
  componentId: "sc-e1c24-2"
})(["display:flex;align-items:baseline;flex-wrap:wrap;"]);
export var Header = function Header(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    subtitleVariant = _ref.subtitleVariant,
    onExpand = _ref.onExpand,
    titleVariant = _ref.titleVariant,
    subsections = _ref.subsections,
    onSubsectionChange = _ref.onSubsectionChange,
    link = _ref.link,
    activeSubsectionId = _ref.activeSubsectionId,
    _ref$selectProps = _ref.selectProps,
    selectProps = _ref$selectProps === void 0 ? {} : _ref$selectProps,
    size = _ref.size,
    expandedActionText = _ref.expandedActionText;
  var handleSubsectionChange = function handleSubsectionChange(event) {
    onSubsectionChange(event.id);
  };
  var hasHeader = Boolean(title) || Boolean(subtitle) || subsections.length;
  return React.createElement(React.Fragment, null, titleVariant === 'default' && hasHeader ? React.createElement(HeaderBlock, null, React.createElement("div", null, title ? React.createElement(Flex, {
    justify: "space-between"
  }, React.createElement(Title, {
    size: size,
    bottomMargin: !subtitle
  }, title)) : null, subtitle ? React.createElement(Subtitle, {
    variant: subtitleVariant
  }, subtitle) : null), subsections.length || link ? React.createElement(ExpandContainer, null, subsections.length ? React.createElement(Select, _extends({
    selected: activeSubsectionId,
    options: subsections.map(function (item) {
      return {
        id: item.id,
        label: item.name
      };
    }),
    onChange: handleSubsectionChange
  }, selectProps)) : null, link ? React.createElement(BottonViewMore, _extends({
    as: "a",
    href: link.href
  }, link.rel ? {
    rel: link.rel
  } : {}), link.text) : null) : null, onExpand ? React.createElement(ExpandContainer, null, React.createElement(SectionAction, {
    onClick: onExpand,
    expandedActionText: expandedActionText
  })) : null) : null, titleVariant === 'centered' ? React.createElement(CenteredTitle, {
    title: title || '',
    subtitle: subtitle || ''
  }) : null);
};